<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-container fluid class="pa-0">
        <v-row dense>
            <!-- {{managementDateRange.startDate}}～{{managementDateRange.endDate}}/NewRecord={{isNewWorkRecord}} -->
            <v-col v-for="chemical in selectedAgrichemicals" :key="chemical.agrichemicalNo" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                <v-card class="mb-2 mt-2">
                    <v-card-text class="pa-0">
                        <table v-if="$vuetify.breakpoint.xs" class="pa-1 font-weight-bold body-1" >
                            <tr>
                                <td style="width:100%">{{targetAgrichemicalItems[chemical.agrichemicalNo].name}}</td>
                            </tr>
                            <tr>
                                <td>{{useCount(chemical)}}回目<span v-if="chemical.limit != 0">({{chemical.limit}}回まで)</span></td>
                            </tr>
                        </table>
                        <table v-else class="pa-1 font-weight-bold body-1">
                            <tr>
                                <td style="width:100%">{{targetAgrichemicalItems[chemical.agrichemicalNo].name}}</td>
                                <td>{{useCount(chemical)}}回目<span v-if="chemical.limit != 0">({{chemical.limit}}回まで)</span></td>
                            </tr>
                        </table>
                        <v-divider />
                        <v-container fluid class="pt-0 pb-0">                            
                            <v-row dense>
                                <v-col>
                                    <v-chip label small class="ma-1">希釈倍率:{{agrichemicalDilution(targetAgrichemicalItems[chemical.agrichemicalNo])}}</v-chip>
                                    <v-chip label small class="ma-1">系統:{{targetAgrichemicalItems[chemical.agrichemicalNo].strain}}</v-chip>
                                    <v-chip label small class="ma-1">分類コード:{{targetAgrichemicalItems[chemical.agrichemicalNo].classificationCode}}</v-chip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col v-if="hasSupportSick(chemical)" cols="12" xs="12" sm="12" md="12" lg="12" xl="6">
                                    <v-select 
                                        :style="$vuetify.breakpoint.xs ? 'font-size:x-small' : ''"
                                        dense
                                        v-model="chemical.sick" 
                                        label="対象病気" 
                                        outlined 
                                        hide-details
                                        :items="selectedAgrichemicalSicks(chemical)" 
                                        item-text="name"
                                        item-value="sickNo"
                                        clearable
                                        @change="onChangedSick(chemical)" />
                                </v-col>
                                <v-col v-if="hasSupportVermin(chemical)" cols="12" xs="12" sm="12" md="12" lg="12" xl="6">
                                    <v-select                                        
                                        :style="$vuetify.breakpoint.xs ? 'font-size:x-small' : ''"
                                        dense
                                        v-model="chemical.vermin" 
                                        label="対象害虫" 
                                        outlined 
                                        hide-details
                                        :items="selectedAgrichemicalVermins(chemical)" 
                                        item-text="name"
                                        item-value="verminNo"
                                        clearable
                                        @change="onChangedVermin(chemical)" />
                                </v-col>
                            </v-row>
                            <v-row dense>                                            
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" >
                                    <NumInput 
                                        v-model="chemical.dilution" 
                                        outlined
                                        hide-details
                                        label="希釈倍率"
                                        type="text" 
                                        align="align-left"
                                        :canEdit="canEdit"
                                        dense />
                                </v-col>
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" >
                                    <NumInput 
                                        v-model="chemical.prevatication" 
                                        suffix="L"
                                        outlined
                                        hide-details 
                                        label="散布量(L)"
                                        type="text" 
                                        align="align-left"
                                        :canEdit="canEdit"
                                        dense />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col>
                                    <div class="caption" v-html="agrichemicalMixState(chemical)" />
                                </v-col>
                            </v-row>
                            <v-row dense v-if="targetAgrichemicalItems[chemical.agrichemicalNo].memo != ''">
                                <v-col>
                                    <v-textarea
                                        readonly
                                        color="black--text"
                                        background-color="yellow lighten-2"
                                        class="black--text mb-1"
                                        outlined
                                        hide-details
                                        auto-grow
                                        rows="3"
                                        :value="targetAgrichemicalItems[chemical.agrichemicalNo].memo"
                                        :style="$vuetify.breakpoint.xs ? 'font-size:x-small' : ''"
                                        >
                                    </v-textarea>
                                    <!-- <div
                                        class="yellow lighten-2 black--text pt-1 pb-1 pl-1 mb-1"
                                        :style="$vuetify.breakpoint.xs ? 'font-size:x-small' : ''">
                                        {{targetPlace.agrichemicals[chemical.agrichemicalNo].memo}}
                                    </div> -->
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions v-if="canEdit">
                        <v-spacer />
                        <v-btn class="ma-1" color="warning" @click="onClickDeleteAgrichemical(chemical)"><v-icon>mdi-delete</v-icon>削除</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="canEdit">
            <v-col>
                <v-btn block @click="onClickAdd" color="primary"><v-icon>mdi-plus-circle-outline</v-icon>
                    {{selectedAgrichemicals == null || selectedAgrichemicals.length == 0 ? '使用農薬追加' : '混用薬品追加'}}
                </v-btn>
            </v-col>
        </v-row>
        <SelectorAgrichemical 
            ref="selector"
            @onSelectedAgrichemical="onSelectedAgrichemical"
            :targetPlace="targetPlace"
            :selectedAgrichemicals="selectedAgrichemicals"
            :workDate="workDate"
            :managementDateRange="managementDateRange" />
    </v-container>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }
    Date.prototype.addDay = function (v) {
        this.setDate(this.getDate()+v)
        return this
    }
    Date.prototype.diffMonth = function (d) {
        return (this.getFullYear() * 12 + this.getMonth()) - (d.getFullYear() * 12 + d.getMonth())
    }

    import SelectorAgrichemical from '@/components/place/SelectorAgrichemical'
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    export default {
        components: {
            SelectorAgrichemical,
            NumInput
        },
        props: {
            value: {
                type: Array,
                //     {
                //         /** 対象農薬 */
                //         target: 0,
                //         /** 農薬No. */
                //         agrichemicalNo: 0,
                //         /** 希釈倍率 */
                //         dilution: 100,
                //         /** 散布量 */
                //         prevatication: 50,
                //         /** 病気 */
                //         sick:,
                //         /** 害虫 */
                //         vermin:,
                //         /** 回数(起点日から何回目の使用になるか)(未使用とする) */
                //         count: 0
                //         /** 制限回数 */
                //         limit: 0 
                //     }
                default: []
            },
            /** 対象の場所 */
            targetPlace: null,
            /** 作業日(使用回数の算出の為) */
            workDate: "",
            /** 編集可否 */
            canEdit: false,
            /** 新しい作業記録か否か */
            isNewWorkRecord: false
        },
        data: function () {
            return {
                /** 病気セレクターの選択項目を格納する配列 */
                sicks: [],
                /** 害虫セレクターの選択項目を格納する配列 */
                vermins: [],
                /** 農薬管理の日付範囲 */
                managementDateRange: {
                    startDate: "",
                    endDate: ""
                }
            }
        },
        computed: {
            /**
             * 選択されている全ての農薬
             */
            selectedAgrichemicals: {
                get: function () {
                    return this.$props.value
                },
                set: function (v) {
                    this.$emit("input", v)
                }
            },
            /**
             * 場所に設定されている全農薬
             */
            targetAgrichemicalItems: function () {
                const agrichemical = this.$store.getters["managementItems/agrichemicals"].find((v)=>v.body.target == this.targetPlace.body.managementAgrichemical.target)
                return agrichemical.items
            }
        },
        watch: {
            /** 作業日の監視 */
            workDate: function () {
                this.refreshManagementRange()
            }
        },
        created: function () {
            console.log("PlaceWorkRecorderAgrichemical", "created", this.selectedAgrichemicals, this.targetPlace)
            if (this.selectedAgrichemicals == "") {
                this.selectedAgrichemicals = []
            }
            this.sicks = []
            const sicks = this.$store.getters["managementItems/sicks"]
            for (var key in sicks.list) {
                this.sicks.push(sicks.list[key])
            }

            this.vermins = []
            const vermins = this.$store.getters["managementItems/vermins"]
            for (var key in vermins.list) {
                this.vermins.push(vermins.list[key])
            }
            // 回数を管理する日付の範囲を算出
            this.refreshManagementRange()
        },
        methods: {
            /**
             * 使用薬品追加ボタン押下時
             */
            onClickAdd: function () {
                this.$refs.selector.show()
            },
            /**
             * 農薬の削除ボタン押下時
             */
            onClickDeleteAgrichemical: function (chemical) {
                const index = this.selectedAgrichemicals.findIndex((v)=>v.agrichemicalNo == chemical.agrichemicalNo)
                this.selectedAgrichemicals.splice(index, 1)
            },
            /**
             * 農薬選択時
             */
            onSelectedAgrichemical: function (chemical) {   
                const listItem = {
                    target: chemical.body.target,
                    agrichemicalNo: chemical.body.agrichemicalNo,
                    dilution: chemical.body.dilution.min != null ? chemical.body.dilution.min : chemical.body.dilution.max != null ? chemical.body.dilution.max : 0,
                    prevatication: 0,
                    count: chemical.usedNum + 1,
                    limit: chemical.body.useLimitNum,
                    sick: null,
                    vermin: null
                }
                this.selectedAgrichemicals.push(listItem)
            },
            /**
             * 病気選択時
             * 害虫の選択をクリアする。
             */
            onChangedSick: function (agrichemical) {
                if (agrichemical.sick != null) {
                    agrichemical.vermin = null
                }
            },
            /**
             * 害虫選択時
             * 病気の選択をクリアする。
             */
            onChangedVermin: function (agrichemical) {
                if (agrichemical.vermin != null) {
                    agrichemical.sick = null
                }
            },
            refreshManagementRange: function () {
                var workDate = new Date(this.workDate)
                var startDate = new Date(workDate.getFullYear(), this.targetPlace.body.managementAgrichemical.startDate.month - 1, this.targetPlace.body.managementAgrichemical.startDate.day)
                if (workDate < startDate) {
                    startDate = new Date(workDate.getFullYear() - 1, this.targetPlace.body.managementAgrichemical.startDate.month - 1, this.targetPlace.body.managementAgrichemical.startDate.day)
                }
                var endDate = (new Date(startDate.getFullYear()+1, startDate.getMonth(), startDate.getDate())).addDay(-1)
                this.managementDateRange.startDate = startDate.toFormatString("yyyy-MM-dd")
                this.managementDateRange.endDate = endDate.toFormatString("yyyy-MM-dd")

                console.log("PlaceWorkRecorderAgrichemical", "refreshManagementRange", "managementDateRange", this.managementDateRange)
            },
            /**
             * 表示する使用回数を返す(x回目のxを返す)
             * (選択されている作業日と管理起点の開始日及び農薬の履歴から算出する)
             * (同じ日に既に使用履歴がある時は、その履歴より後に使用された事とする)
             */
            useCount: function (agrichemical) {
                const self = this
                const chemicalHistory = this.targetPlace.agrichemicalsHistory.agrichemicals[agrichemical.agrichemicalNo]

                if (chemicalHistory == null) {
                    return 1
                }
                
                const histories = chemicalHistory.histories.filter(function (v) {return v.date >= self.managementDateRange.startDate && v.date <= self.workDate})

                if (histories.length > 0) {
                    histories.sort(function(x, y){
                        if (x.date > y.date) return 1
                        if (x.date < y.date) return -1
                        return 0
                    })
                }

                const lastHistory = histories.length > 0 ? histories[histories.length-1] : null

                var usedNum = chemicalHistory != null ? histories.length : 0
                
                console.log("PlaceWorkRecorderAgrichemical", "useCount", histories)

                // 履歴がない場合
                // 最終使用履歴の日付が作業日より前
                // 最終使用履歴の日付=作業日で、かつ新規の作業記録
                // 上記いづれかの時は、算出した使用回数に+1する
                if (lastHistory == null || lastHistory.date < this.workDate || (lastHistory.date == this.workDate && this.isNewWorkRecord)) {
                    if (lastHistory == null) {
                        console.log("履歴がない")
                    } else if (lastHistory.date < this.workDate) {
                        console.log("最終使用履歴の日付が作業日より前")
                    } else if (lastHistory.date == this.workDate && this.isNewWorkRecord) {
                        console.log("最終使用履歴の日付=作業日で、かつ新規の作業記録")
                    }
                    usedNum++
                }

                console.log("useCount", agrichemical, usedNum, agrichemical.count)
                return usedNum
            },
            /**
             * 指定された農薬が病気に対応しているか否かを返す
             */
            hasSupportSick: function (chemical) {
                const agrichemical = this.targetAgrichemicalItems[chemical.agrichemicalNo] // this.targetPlace.agrichemicals[chemical.agrichemicalNo]
                console.log("hasSupportSick", chemical, agrichemical, this.targetAgrichemicalItems)
                if (agrichemical.sicks != null && agrichemical.sicks.length > 0) {
                    return true
                }
                return false
            },
            /**
             * 指定された農薬が害虫に対応しているか否かを返す
             */
            hasSupportVermin: function (chemical) {
                const agrichemical = this.targetAgrichemicalItems[chemical.agrichemicalNo] // this.targetPlace.agrichemicals[chemical.agrichemicalNo]
                if (agrichemical.vermins != null && agrichemical.vermins.length > 0) {
                    return true
                }
                return false
            },
            /**
             * 指定された農薬が対応している病気のリストを返す(セレクター用)
             */
            selectedAgrichemicalSicks: function (chemical) {
                const agrichemical = this.targetAgrichemicalItems[chemical.agrichemicalNo] // this.targetPlace.agrichemicals[chemical.agrichemicalNo]
                const list = []
                // 対応している病気をセット
                for (var i=0; i<agrichemical.sicks.length; i++) {
                    const sickNo = agrichemical.sicks[i]
                    const sickData = this.sicks.find((v)=>v.sickNo == sickNo)
                    if (sickData != null) {
                        list.push(sickData)
                    }
                }
                // 対応していない病気をセット
                for (var i=0; i<this.sicks.length; i++) {
                    const sick = this.sicks[i]
                    if (list.findIndex((v)=>v.sickNo == sick.sickNo) < 0) {
                        list.push(sick)
                    }
                }
                return list
            },
            /**
             * 指定された農薬が対応している害虫のリストを返す(セレクター用)
             */
            selectedAgrichemicalVermins: function (chemical) {
                const agrichemical = this.targetAgrichemicalItems[chemical.agrichemicalNo] // this.targetPlace.agrichemicals[chemical.agrichemicalNo]
                const list = []
                // 対応している害虫をセット
                for (var i=0; i<agrichemical.vermins.length; i++) {
                    const verminNo = agrichemical.vermins[i]
                    const verminData = this.vermins.find((v)=>v.verminNo == verminNo)
                    if (verminData != null) {
                        list.push(verminData)
                    }
                }
                // 対応していない病気をセット
                for (var i=0; i<this.vermins.length; i++) {
                    const vermin = this.vermins[i]
                    if (list.findIndex((v)=>v.verminNo == vermin.verminNo) < 0) {
                        list.push(vermin)
                    }
                }
                return list
            },
            /**
             * 指定された農薬の一覧に表示する希釈倍率を返す
             */
            agrichemicalDilution: function (agrichemical) {
                if (agrichemical.dilution.min != null && agrichemical.dilution.max != null) {
                    return agrichemical.dilution.min + "～" + agrichemical.dilution.max
                } else if (agrichemical.dilution.min != null) {
                    return agrichemical.dilution.min
                } else if (agrichemical.dilution.max != null) {
                    return agrichemical.dilution.max
                }
            },
            /**
             * 選択されている農薬同士の混用状況のテキストを返す
             */
            agrichemicalMixState: function (agrichemical) {
                // １つの農薬のみの時は、何も表示しない
                if (this.selectedAgrichemicals.length == 0) {
                    return ""
                }

                // 指定された農薬以外の農薬との混用値
                const mixResults = []
                const agrichemicalBase = this.$store.getters["managementItems/agrichemicals"].find((v)=>v.body.target == agrichemical.target)
                const sourceChemical = this.targetAgrichemicalItems[agrichemical.agrichemicalNo] //this.targetPlace.agrichemicals[agrichemical.agrichemicalNo]

                console.log("混用状況", sourceChemical.name, sourceChemical.mixList, agrichemicalBase)

                for (var i=0; i<this.selectedAgrichemicals.length; i++) {
                    if (this.selectedAgrichemicals[i].agrichemicalNo != agrichemical.agrichemicalNo) {
                        var mix = sourceChemical.mixList[this.selectedAgrichemicals[i].agrichemicalNo]
                        if (mix == null) {
                            mix = 0
                        }
                        console.log(this.selectedAgrichemicals[i], mix)
                        const mixInfo = agrichemicalBase.body.mixInfo.find((v)=>v.value == mix)
                        const targetChemical = this.targetAgrichemicalItems[this.selectedAgrichemicals[i].agrichemicalNo] //this.targetPlace.agrichemicals[this.selectedAgrichemicals[i].agrichemicalNo]
                        // mixResults.push("<span class='red--text'>" + targetChemical.name+":"+mixInfo.mark + "</span>")
                        mixResults.push("<span style='color:"+mixInfo.color+"'>" + targetChemical.name+":"+mixInfo.mark + "</span>")
                    }
                }

                return mixResults.join("<br/>")
            }
        }
    }
</script>
